import { useMemo } from 'react';

import { buildOverridesFromMessages } from '../../transcript/buildOverridesFromMessages';
import { useTranscriptContext } from '../../transcript/utils/useTranscriptContext';
import { useAppContext } from './useAppContext';

/**
 * Returns message-content overrides when the current session is private,
 * or undefined otherwise. Centralises the isPrivate check so callers
 * don't duplicate the pattern.
 */
export const usePrivacyOverrides = () => {
  const { state: appState } = useAppContext();
  const { state } = useTranscriptContext();

  return useMemo(
    () =>
      appState.isPrivate === true
        ? buildOverridesFromMessages(state.messages)
        : undefined,
    [appState.isPrivate, state.messages],
  );
};
